import { useSearchParams } from "react-router-dom";

import { api } from "../lib/api";

/**
 * Landing page shown when a visitor hits the portal without a session.
 * Two paths:
 *   - Existing supplier → Sign In (SAML SSO via MiniOrange)
 *   - Prospective supplier → Register (anonymous session cookie + wizard)
 *
 * Per brief §17 the registration path doesn't require SAML, so prospects
 * can fill out the new-supplier wizard without an IdP account.
 */
export default function SignIn() {
  const [searchParams] = useSearchParams();
  const returnTo = searchParams.get("return_to") || "/supplier";

  const handleSignIn = () => {
    // Top-level navigation, NOT fetch — SAML SSO requires a real browser
    // redirect so the IdP can set its own cookies.
    window.location.href = `/api/auth/saml/login?return_to=${encodeURIComponent(returnTo)}`;
  };

  const handleRegister = async () => {
    await api.post("/auth/registration-session");
    window.location.href = returnTo;
  };

  return (
    <main className="container py-5">
      <div className="row justify-content-center">
        <div className="col-md-10 col-lg-9">
          <div className="text-center mb-4">
            <img
              src={import.meta.env.VITE_AFB_LOGO_URL}
              alt="Alliance Franchise Brands"
              style={{ height: 64, width: "auto" }}
            />
          </div>

          <div className="row g-4">
            {/* Existing supplier card */}
            <div className="col-md-6">
              <div className="card shadow-sm h-100">
                <div className="card-body p-4 text-center">
                  <h2 className="h5 mb-3">Existing Account</h2>
                  <p className="text-muted small mb-3">
                    Sign in with your Alliance Franchise Brands account to
                    manage your existing listing.
                  </p>
                  <button
                    type="button"
                    className="btn btn-primary w-100 mb-2"
                    onClick={handleSignIn}
                  >
                    <i className="fa-solid fa-right-to-bracket me-2" aria-hidden="true" />
                    Sign In
                  </button>
                  <p className="small mb-0">
                    <a
                      href={import.meta.env.VITE_FORGOT_PASSWORD_URL}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Forgot Your Password?
                    </a>
                  </p>
                </div>
              </div>
            </div>

            {/* New supplier card */}
            <div className="col-md-6">
              <div className="card shadow-sm h-100">
                <div className="card-body p-4 text-center">
                  <h2 className="h5 mb-3">Register New Supplier</h2>
                  <p className="text-muted small mb-3">
                    Register your business as a supplier. Submit the form and
                    the Supplier Relations team will review your listing.
                  </p>
                  <button
                    type="button"
                    className="btn btn-primary w-100"
                    onClick={handleRegister}
                  >
                    <i className="fa-solid fa-user-plus me-2" aria-hidden="true" />
                    Register
                  </button>
                </div>
              </div>
            </div>
          </div>

          <p className="text-center text-muted small mt-3">
            Need help? Email{" "}
            <a
              href={`mailto:${import.meta.env.VITE_SUPPORT_EMAIL}?subject=Supplier%20Portal%20Help`}
            >
              {import.meta.env.VITE_SUPPORT_EMAIL}
            </a>
          </p>
        </div>
      </div>
    </main>
  );
}
